// src/components/registry/CategoryGroup.tsx
//
// Presentational grouping of catalog entries that share a Category. Renders a
// Category heading followed by one ServerCard per entry, preserving the input
// order of `entries` (Requirements 1.5, 1.6).

import { ServerCard } from './ServerCard'
import type { CatalogEntry } from '../../lib/catalog'

interface CategoryGroupProps {
  category: string
  entries: CatalogEntry[]
  baseUrl?: string
}

export function CategoryGroup({ category, entries, baseUrl }: Readonly<CategoryGroupProps>) {
  return (
    <section style={{ marginBottom: 'var(--space-4)' }}>
      <h2
        style={{
          fontSize: 13,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          color: 'var(--text-secondary)',
          marginBottom: 'var(--space-2)',
        }}
      >
        {category}
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
        {entries.map((entry) => (
          <ServerCard key={entry.id} entry={entry} baseUrl={baseUrl} />
        ))}
      </div>
    </section>
  )
}
